export const THEME_COLORS = {
  LIGHT: {
    backgroundPrimary: '#FAFAFA',
    backgroundHover: '#F2F2F2',
    textPrimary: '#131722',
    textSecondary: '#6A6D78',
    textBody: '#131722',
    iconPrimary: '#131722',
    iconBackgroundHover: '#F2F2F2',
    linkHover: '#2962FF',
  },
  DARK: {
    backgroundPrimary: '#1A1A1A',
    backgroundHover: '#262626',
    textPrimary: '#DBDBDB',
    textSecondary: '#8C8C8C',
    textBody: '#DBDBDB',
    iconPrimary: '#DBDBDB',
    iconBackgroundHover: '#303030',
    linkHover: '#2962FF',
  },
};
